import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import { v4 as uuid } from 'uuid';

export const useUploadController = () => {
	const { userAgencyData, userAgencyId } = useAuth();
	const { handleImageUploading, imagePreview, setImagePreview, fileImagesUpload, setFileImagesUpload } = useData();

	const handleUploadImage = async (Files: any) => {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		let cnpj = userAgencyData[0].CNPJ_ORGAO;

		cnpj = cnpj.replace(/\D/g, '');

		const uploadedFilesImages: any = [];
		await Promise.all(
			Files.map((file: any) => {
				setImagePreview(imagePreview.concat(URL.createObjectURL(file)));
				uploadedFilesImages.push(file);
			})
		);

		setFileImagesUpload(fileImagesUpload.concat(uploadedFilesImages));

		handleImageUploading(Files);
	};

	const processUploadFileImage = async (Files: any, category: string, tabela: string, id: string) => {
		let cnpj = userAgencyData[0].CNPJ_ORGAO;

		cnpj = cnpj.replace(/\D/g, '');

		const uploadedFilesImages: any = [];
		if (!!Files) {
			await Promise.all(
				Files.map((file: any) => {
					const idImage = uuid();
					let fileType = file.type.split('/')[1];
					let name = `${cnpj}_${category}_${id}_${idImage}.${fileType}`;
					const formattedFile = new File([file], name, {
						type: file.type,
						lastModified: file.lastModifed,
					});

					uploadedFilesImages.push(formattedFile);
				})
			);
		}

		if (!!uploadedFilesImages) {
			uploadedFilesImages.forEach((image: any, index: number) => {
				const data = new FormData();
				data.append('image', image);

				api.post('/upload', data, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
					params: {
						ORGAO: userAgencyId,
						DESCRICAO: `Foto de ${category}`,
						TABELA: tabela,
						TABLEAID: id,
					},
				})
					.then((response) => {
						console.log('post: ', response);
					})
					.catch((err) => console.log(err));
			});
		}
	};

	return {
		handleUpload: {
			handleUploadImage,
			processUploadFileImage,
		},
	};
};
